export const strings = {
  id: 'ID',
  dashboard: 'Dashboard',
  address: 'Address',
  city: 'City',
  area: 'Area',
  save: 'Save',
  house_number: 'House Number',
  landmark: 'Landmark',
  save_changes: 'Save Changes',
  delete_ok: 'Are you sure you want to delete?',
  are_you_sure_perform_action: 'Are you sure you want to perform this action?',
  location_delete_msg: 'Location has been successfully deleted.',
  location_create_msg: 'Location has been successfully created.',
  location_update_msg: 'Location updated successfully',
  read_more: 'Read More',
  read_less: 'Read Less',
  no_notifications_yet: 'No notifications yet',
  duration_in_days: 'Duration (in days)',
  delete_warranty: 'Delete Warranty',
  delete_warranty_msg: 'Are you sure you want to delete',
  delete_warehouse: 'Delete',
  orders: 'Orders',
  order_reason: 'Order Reason',
  orders_listing: 'Orders Listing',
  listing: 'Listing',
  payments_summary: 'Payments Summary',
  return_orders: 'Return Orders',
  return_order_id: 'Return Order ID',
  buyer_name: 'Buyer Name',
  refund: 'Refund',
  refund_amount: 'Refund Amount',
  confirm_refund: 'Confirm Refund',
  return_order_details: 'Return Order Details',
  no_of_orders: 'No. of Orders',
  products: 'Products',
  reports: 'Reports',
  no_of_products: 'No. of Products',
  products_count: 'Products Count',
  published: 'Published',
  total: 'Total',
  product_id: 'Product ID',
  buyer_id: 'Buyer ID',
  product_listing: 'Product Listing',
  products_listing: 'Products Listing',
  reviews_listing: 'Reviews Listing',
  publish_product: 'Publish Product',
  published_products: 'Published Products',
  manage_products: 'Manage Products',
  add_product: 'Add Product',
  manage_orders: 'Manage Orders',
  shipments: 'Shipments',
  reviews: 'Reviews',
  review: 'Review',
  write_a_reply: 'Write a Reply',
  finance: 'Finance',
  order_overview: 'Order Overview',
  sales_report: 'Sales Report',
  transaction_history: 'Transaction History',
  transaction_overview: 'Transaction Overview',
  account_statement: 'Account Statement',
  account_statements: 'Account Statements',
  marketing: 'Marketing',
  buy_packages: 'Buy Packages',
  usage_history: 'Usage History',
  chat: 'Chat',
  start_chat: 'Start Chat',
  settings: 'Settings',
  account_settings: 'Account Settings',
  manage_users: 'Manage Users',
  profile_settings: 'Profile Settings',
  delivery_settings: 'Delivery Settings',
  chat_settings: 'Chat Settings',
  last_seen: 'Last seen',
  start_a_conversation: 'Start a conversation to sell faster.',
  your_messages_will_show_here: 'Your messages will show up here.',
  sub_order_id: 'Sub Order ID',
  order_id: 'Order ID',
  consignment: 'Consignment',
  consignment_num: 'Consignment',
  item_id: 'Item ID',
  your_reply: 'Your Reply',
  reply: 'Reply',
  reply_from: 'Reply from',
  impressions: 'Impressions',
  views: 'Clicks',
  clicks_tooltip_text: 'People who viewed this product',
  are_you_sure_accept_items: 'Are you sure you want to accept these items:',
  are_you_sure_create_shipment: 'Are you sure you want to create a shipment for',
  are_you_sure_generate_consignment: 'Are you sure you want to generate a consignment for',
  are_you_sure_confirm_pickup: 'Are you sure you want to confirm the pickup for',
  are_you_sure_approve_product_moderation: 'Are you sure you want to approve all pending product categories of store ',
  invalid_shipment_id: 'The provided shipment ID is invalid.',
  add_valid_external_id: 'Add a valid external ID',
  order_is_ready_for_pickup: 'Order is ready for Pick-up.',
  shipment_created: 'Shipment has been successfully created.',
  order_accepted: 'Order has been successfully accepted.',
  order_dispatched: 'Order has been successfully dispatched.',
  order_delivered: 'Order has been successfully delivered.',
  order_marked_as_returned: 'The order has been successfully marked as returned.',
  select_atleast_one_order_item: 'Please select at least one order item.',
  product_status_updated: 'Product status has been successfully updated.',
  settings_updated_successfully: 'Settings has been successfully updated.',
  stock_updatted_successfully: 'Stock has been successfully updated.',
  failed_to_update_comment: 'Failed to update comment.',
  actual_order_id: 'actual_order_id',
  order_price: 'Order Price',
  buyer: 'Buyer Details',
  caller_name: 'Caller Name',
  placed_on: 'Placed On',
  status: 'Status',
  robo_call: 'Robo Call',
  robo_call_status: 'Robo Call Status',
  sort_by: 'Sort by:',
  delivered_on: 'Delivered On',
  delivered: 'Delivered',
  cancelled: 'Cancelled',
  total_refund: 'Total Refund',
  refund_reason: 'Refund Reason',
  rejection_reason: 'Rejection Reason',
  return_reason: 'Return Reason',
  item_details: 'Item Detail',
  lowest_price: 'Price: Low to High',
  highest_price: 'Price: High to Low',
  lowest_commission: 'Commission: Low to High',
  highest_commission: 'Commission: High to Low',
  lowest_amount: 'Amount: Low to High',
  highest_amount: 'Amount: High to Low',
  newly_placed: 'Newly Placed',
  actions: 'Actions',
  all: 'All',
  upload: 'Upload',
  submit: 'Submit',
  upload_images: 'Upload Images',
  view_more: 'View More',
  drag_image_text: 'Drag to reorder and double tap to make cover photo.',
  select_a_category: 'Select product category',
  category_commission: 'Category Commission',
  minimum_commission_slabs: 'Minimum Commission Slabs',
  minimum_commission_slab_desc:
    'If the category commission percentage results in an amount lower than the slab value below, the slab fee will apply instead.',
  category_id: 'Category ID',
  category_name: 'Category Name',
  confirm: 'Confirm',
  ntn_strn_required: 'NTN & STRN Verification Required',
  scan_qr_code: 'Scan QR Code',
  scan_to_connect: 'Scan To Connect with Prop GO',
  generate_qr_code: 'Generate QR Code',
  basic_information: 'Basic Information',
  category: 'Category',
  enter_product_title: 'Enter product title',
  product_title: 'Product Title',
  enter_product_overview: 'Enter product overview',
  enter_product_description: 'Enter product description',
  title: 'Title',
  field_not_valid_msg: 'This field is not valid',
  weight_required_msg: 'Weight is required.',
  house_number_required_msg: 'House number is required.',
  landmark_required_msg: 'Landmark is required.',
  valid_email_msg: 'Please enter a valid email address',
  valid_pass_msg: 'Please enter a valid password',
  alphabets_only_msg: 'This field can only contain alphabets',
  digits_only_msg: 'This field can only contain digits',
  overview: 'Overview',
  description: 'Description',
  business_description: 'Business Description',
  enter_business_description: 'Enter Business Description',
  trn_number: 'Tax Registration Number',
  enter_trn_number: 'Enter Tax Registration Number (TRN)',
  tr_certificate: 'TRN Certificate',
  trade_license: 'Trade License',
  product_specifications: 'Product Specifications',
  add_another_specification: 'Add another specification',
  hide_specifications: 'Hide Specifications',
  specification_name: 'Specification Name',
  enter_specification: 'Enter spec. e.g. Material',
  enter_description: 'Enter description e.g. Cotton',
  remove: 'Remove',
  price_and_stock: 'Price & Stock',
  enter_price: 'Enter Price',
  enter_discounted_price: 'Enter Discounted Price',
  pickup_location: 'Pickup Location',
  select_location: 'Select Location',
  sku: 'SKU',
  enter_sku: 'Enter SKU',
  package_size: 'Package Size',
  length: 'Length',
  width: 'Width',
  height: 'Height',
  weight: 'Weight',
  enter_length: 'Enter Length',
  enter_width: 'Enter Width',
  enter_height: 'Enter Height',
  enter_weight: 'Enter Weight',
  quantity: 'Quantity',
  enter_quantity: 'Enter Quantity',
  shipping: 'Shipping Details',
  shipping_col: 'Shipping',
  pickUpLocation: 'Pick up Location',
  consignment_number: 'CN #',
  consignment_status: 'Consignment Status',
  cheque_date: 'Cheque Date',
  cheque_number: 'Cheque #',
  warranty_return_delivery: 'Warranty, Return & Delivery',
  warranty_type: 'Warranty Type',
  return_policy: 'Return Policy',
  select_warranty_type: 'Select warranty type',
  select_return_policy: 'Select return policy',
  delivery_charges: 'Delivery Charges',
  update: 'Update',
  delete: 'Delete',
  edit: 'Edit',
  preview: 'Preview',
  view_orders: 'View Orders',
  share: 'Share',
  N_A: 'N/A',
  stats: 'Stats',
  advertise: 'Advertise',
  inline: 'inline',
  show_more: 'show more',
  updated_at: 'Updated at',
  updated_by: 'Updated by:',
  update_stock: 'Update Stock',
  out_of_stock: 'out of stock',
  quick_update: 'Quick Update',
  variants: 'Variants',
  add_variants: 'Add Variants',
  add_another_option: 'Add another option',
  add_another_variant: 'Add another variant',
  variant_option: 'Variant Option',
  variant_name: 'Variant Name',
  variant_msg: 'Enter variant name e.g. Color',
  variant_value: 'Enter variant option e.g. Black',
  enter_another_value: 'Enter another value',
  done: 'Done',
  created_at: 'Created at',
  courier: 'Courier',
  image: 'Image',
  images: 'Images',
  name: 'Name',
  category_fields: 'Category Fields',
  storage: 'Storage',
  price: 'Price',
  discount_percentage: 'Discount %',
  stock_location: 'Stock Location',
  in_stock: 'In Stock',
  delete_product: 'Delete Product',
  product_deleted_successfully: 'Product Deleted Successfully',
  accept_order: 'Accept Order',
  item: 'Item',
  total_amount: 'Total Amount',
  total_fee: 'Total Fee',
  items: 'Items',
  line_items: 'Item (s)',
  order_total: 'Order Total',
  shipping_charges: 'Shipping Charges',
  tenant_shipping_charges: 'Tenant Shipping Charges',
  customer_shipping_charges: 'Customer Shipping Charges',
  sales_tax: 'Sales Tax',
  income_tax: 'Income Tax',
  commission_fee: 'Commission Fee',
  pending_order_items: 'Pending Order Items',
  accepted_order_items: 'Accepted Order Items',
  cancel_order: 'Cancel Order',
  confirm_order: 'Confirm Order',
  create_shipment: 'Create Shipment',
  generate_consignment: 'Generate Consignment',
  confirm_pickup: 'Confirm Pickup',
  dispatch: 'Dispatch',
  mark_delivered: 'Mark Delivered',
  select_reason_for_canceling: 'Please select reason for canceling the order',
  reach_thousands_of_buyers_in_few_simple_steps: 'Reach thousands of buyers in a few simple steps',
  required: 'Required',
  confirmation: 'Confirmation',
  cancellation: 'Cancellation',
  cancellation_reason: 'Cancellation Reason',
  cancel: 'Cancel',
  cancel_payment: 'Cancel Payment',
  order_items: 'Order Items',
  return_items: 'Return Items',
  order_details: 'Order Details',
  view_detail: 'View Detail',
  print: 'Print',
  delivered_orders: 'Delivered Orders',
  print_shipping_label: 'Print Shipping label',
  account_summary: 'Account Summary',
  total_payout: 'Total Payout',
  total_no_of_orders: 'Total No. of Orders',
  view_order_detail: 'View Order detail',
  discount_price: 'Discounted Price',
  set_package_size: 'Set Package Size',
  location: 'Location',
  locations: 'Locations',
  message: 'Message',
  enter_message: 'Enter Message',
  add_another_stock_location: 'Add another stock location',
  delete_another_stock_location: 'Delete another stock location',
  option_template_added: 'Option Template Added',
  variant_added_successfully: 'Variant has been successfully added',
  variant_updated_successfully: 'Variant has been successfully updated',
  user_id: 'User ID',
  call_id: 'Call ID',
  user: 'User',
  total_ads: 'Total Ads',
  role: 'Role',
  edit_user: 'Edit User',
  delete_user: 'Delete User',
  add_users: 'Add Users',
  add_user: 'Add User',
  add_Location_message: 'Add Location Message',
  roles: 'Roles',
  calls: 'Calls',
  calls_listing: 'Calls Listing',
  carts_listing: 'Carts Listing',
  abandoned_carts: 'Abandoned Carts',
  calls_count: 'Calls Count',
  select_role: 'Select Role',
  enter_name: 'Enter Name',
  email: 'Email',
  send_welcome_email: 'Send Welcome Email',
  is_welcome_email_sent: 'Is Welcome Email Sent?',
  email_address: 'Email Address',
  enter_email: 'Enter your Email Address',
  email_not_valid: 'Email not valid',
  password: 'Password',
  new_password: 'New Password',
  enter_password: 'Enter your Password',
  forgot_password: 'Forgot your password?',
  reset_password: 'Reset Password',
  create_new_password: 'Create New Password',
  reset_password_token_missing: 'Reset password token is missing',
  reset_password_success_msg: 'Password has been reset successfully',
  reset_password_email_success: 'Reset password link has been sent to your email',
  enter_your_email_msg: 'Enter your email to get a reset link if it is connected to a Seller Center account.',
  send_reset_link: 'Send Reset Link',
  send: 'Send',
  back_to_login: 'Back to Login',
  must_be_atleast_8_char: 'Must be at least 8 characters',
  must_contain_atleast_1_letter: 'Must contain at least 1 letter',
  must_contain_atleast_1_number: 'Must contain at least 1 number',
  must_contain_atleast_1_special_char: 'Must contain at least 1 special character (@, #, $, %, etc)',
  create_new_password_msg: 'To secure your account and login faster, choose a strong password',
  something_went_wrong: 'Something went wrong. Please try again.',
  continue: 'Continue',
  phone_number: 'Phone Number',
  enter_phone: 'Enter Phone',
  add: 'Add',
  add_product_msg: 'Add Product',
  edit_product_msg: 'Edit Product',
  edit_products: 'Edit Products',
  payments: 'Payments',
  pending_orders: 'Pending Orders',
  total_orders: 'Total Orders',
  orders_placed: 'Orders Placed',
  total_pending_orders: 'Total Pending Orders',
  today_stats: "Today's Stats",
  lifetime_stats: 'Lifetime Stats',
  growth_rate: 'Growth Rate',
  select_date: 'Select Date',
  view_all: 'View All',
  view_products: 'View Products',
  ratings: 'Ratings',
  recent_products: 'Recent Products',
  recent_reviews: 'Recent Reviews',
  name_validation: 'Name is required',
  address_validation: 'Address is required',
  city_validation: 'City is required',
  add_location: 'Add Another Location',
  update_Location: 'Update Location',
  area_validation: 'Area is required',
  sales_trends: 'Sales Trends',
  orders_trends: 'Orders Trends',
  no_data: 'No Data',
  key_metrics: 'Key Metrics',
  type_here: 'Type Here',
  variants_have_product_msg: 'Does the product have variants?',
  uploading: 'Uploading',
  add_more: 'Add more',
  active: 'Active',
  in_active: 'Inactive',
  product_description: 'Product Description',
  in: 'in',
  kg: 'kg',
  role_details: 'Role Details',
  role_is_required: 'Role is required',
  name_is_required: 'Name is required',
  email_is_required: 'Email is required',
  password_is_required: 'Password is required',
  values: 'Values',
  options: 'Options',
  variant: 'Variant',
  order_date: 'Order Date',
  platform_fees: 'Platform Fee',
  platform: 'Platform',
  payout_amount: 'Payout Amount',
  payout: 'Payout',
  tracking_id: 'Tracking ID',
  order_status: 'Order Status',
  payout_status: 'Payout Status',
  view: 'View',
  order_summary: 'Order Summary',
  fulfillment: 'Fulfillment',
  fulfillment_summary: 'Fulfillment Summary',
  paid_to_courier: 'Paid to Courier',
  paid_by_3pl: 'Paid by 3PL',
  collected_from_courier: 'Collected from Courier',
  paid_to_seller: 'Paid to Seller',
  report_summary: 'Report Summary',
  cart_summary: 'Cart Summary',
  order_amount: 'Order Amount',
  payment_method: 'Payment Method',
  shipping_address: 'Shipping Address',
  settlement_id: 'Settlement ID',
  settlement_period: 'Settlement Period',
  settlement_status: 'Settlement Status',
  settlement_amount: 'Settlement Amount',
  view_statement: 'View Statement',
  required_field_msg: 'This field is Required',
  discount_error_msg: 'Discount cannot exceed Price',
  discount_cannot_be_less_than_zero: 'Discount cannot be less than 0',
  shop_details: 'Shop Details',
  owner_details: 'Owner Details',
  store_rating: 'Store Rating',
  store_details: 'Store Details',
  store_banner: 'Store Banner',
  upload_store_banner: 'Upload Store Banner',
  avg_product_rating: 'Avg. Product Rating',
  default: 'Default',
  pin_location: 'Pin Location',
  sellers: 'Sellers',
  moderation: 'Moderation',
  add_seller: 'Add Seller',
  seller_listing: 'Seller Listing',
  all_sellers: 'All Sellers',
  categories_moderation: 'Categories',
  type_moderation: 'Category Fields',
  weight_moderation: 'Weight',
  seller_id: 'Seller ID',
  comment_is_required: 'comment is required',
  avaliable_quantity: 'Available Quantity',
  available: 'Available',
  download: 'Download',
  impersonate_seller: 'Impersonate Seller',
  go_to_seller_store: 'Go to Seller Store',
  go_to_seller_center: 'Go to Seller Center',
  bulk_approve_products: 'Bulk Approve Products',
  approve: 'Approve',
  reject: 'Reject',
  seller_name: 'Seller Name',
  amount: 'Amount',
  payment_link: 'Payment Link',
  transfer_amount: 'Transfer Amount',
  transaction_id: 'Transaction ID',
  transaction_proof: 'Transaction Proof',
  bank_name: 'Bank Name',
  iban: 'IBAN',
  proof_of_payment: 'Proof of Payment',
  upload_attachment: 'Upload Attachment',
  enter_transaction_id: 'Enter the Transaction ID',
  enter_transfer_amount: 'Enter the Transfer Amount',
  payment_verification: 'Payment Verification',
  product: 'Product',
  go_to_dashboard: 'Go to Dashboard',
  access_denied: 'Access Denied!',
  Sorry_you_do_not_have_permission_msg:
    'Sorry, you do not have access to this page. Please contact your administrator for more information.',
  back_to_dashboard: 'Back to Dashboard',
  max_6_digits_allowed: 'Max 6 digits allowed',
  max_10_digits_allowed: 'Max 10 digits allowed',
  discounted_price_cannot_be_greater_than_price: 'Discounted Price cannot be greater than Price',
  price_must_not_exceed_10000: 'Price must not exceed 10000',
  payout_amount_exclusive_of_taxes: '*Payout amount is exclusive of taxes',
  total_amount_exclusive_of_taxes: '*Total amount is exclusive of taxes',
  enter_store_name: 'Enter Store Name',
  store_name: 'Store Name',
  preferred_pickup_time: 'Preferred Pickup Time',
  select_days: 'Select Days',
  time_from: 'Time (From)',
  time_to: 'Time (To)',
  select_store_city: 'Select Store City',
  enter_address: 'Enter Address',
  select_store_area: 'Select Store Area',
  select_pin_location: 'Select Pin Location',
  latitude: 'Latitude',
  longitude: 'Longitude',
  enter_store_latitude: 'Enter Store Latitude',
  enter_store_longitude: 'Enter Store Longitude',
  logo: 'Logo',
  banner: 'Banner',
  mobile_banner: 'Mobile Banner',
  store_logo: 'Store Logo',
  upload_store_logo: 'Upload Store Logo',
  upload_attachments: 'Upload Attachments',
  contract_mou: 'Contract / MOU',
  upload_contract_mou: 'Upload Contract / MOU',
  enter_owner_name: 'Enter Owner Name',
  phone_placeholder: '0000 0000000',
  phone_prefix_pakistan: '+92',
  enter_owner_email: 'Enter Owner Email',
  enter_owner_cnic: 'Enter Owner CNIC',
  cnic: 'CNIC',
  cnic_number: 'CNIC Number',
  emirates_id_number: 'Emirates ID Number',
  bank: 'Bank',
  select_bank: 'Select Bank',
  account_name: 'Account Name',
  enter_account_name: 'Enter Account Name',
  enter_iban: 'Enter IBAN',
  ntn: 'NTN',
  strn: 'STRN',
  enter_strn: 'Enter STRN',
  ntn_is_required_for_a_registered_seller: 'NTN is required for a registered seller',
  vat_number: 'VAT Number',
  enter_ntn: 'Enter NTN',
  daraz_url: 'Daraz URL',
  enter_daraz_url: 'Enter Daraz URL',
  cnic_images: 'CNIC Images',
  image_dimensions_must_be: 'Image dimensions must be',
  dimensions_1280x160: 'Dimensions: 1280 x 160',
  dimensions_750x308: 'Dimensions: 750 x 308',
  upload_front_and_back_cnic: 'Upload front and back of your CNIC',
  multiple_attachments_allowed: 'Multiple attachments can be uploaded',
  file_types_pdf_png_jpeg: 'File type can be .pdf, .png, .jpeg',
  file_types_png_jpeg_webp: 'File type can be .png, .jpeg, .webp',
  enter_support_email: 'Enter Support Email',
  add_warranty: 'Add Warranty',
  add_another_warranty: 'Add Another Warranty',
  add_return_policy: 'Add Return Policy',
  add_another_return_policy: 'Add Another Return Policy',
  deactivate: 'Deactivate',
  activate: 'Activate',
  deactivate_product: 'Deactivate Product',
  activate_product: 'Activate Product',
  are_you_sure_deactivate_product: 'Are you sure you want to deactivate this product?',
  are_you_sure_activate_product: 'Are you sure you want to activate this product?',
  are_you_sure_delete_product: 'Are you sure you want to delete this product?',
  status_updated_successfully: 'Status updated successfully',
  three_pl_settlement: '3PL Settlement',
  key_statistics: 'Key Statistics',
  refresh: 'Refresh',
  logout: 'Log Out',
  login: 'Login',
  seller_center: 'Seller Center',
  cp: 'CP',
  go_to_dubizzle: 'Go to Dubizzle.com',
  go_to_olx: 'Go to OLX.com',
  olx_commission: 'OLX Commission',
  is_verified: 'Verified?',
  are_you_sure_deactivate_store: 'Are you sure you want to deactivate this store?',
  are_you_sure_activate_store: 'Are you sure you want to activate this store?',
  are_you_sure_approve_store: 'Are you sure you want to approve this store?',
  are_you_sure_reject_store: 'Are you sure you want to reject this store?',
  approve_store: 'Approve Store',
  reject_store: 'Reject Store',
  deactivate_store: 'Deactivate Store',
  activate_store: 'Activate Store',
  reviewed_at: 'Reviewed at',
  replied_at: 'Replied at',
  clear: 'Clear',
  search_sub_category: 'Search Sub Category',
  search_category: 'Search Category',
  action_completed_successfully: 'Action completed successfully!',
  potential_issue: 'There seems to be a potential issue. Please verify before proceeding.',
  fyi: 'This is for your information.',
  today: 'Today',
  yesterday: 'Yesterday',
  older: 'Older',
  mark_verified: 'Mark Verified',
  are_you_sure_mark_payout_verified: 'Are you sure you want to mark this payout verified?',
  reason: 'Reason',
  is_the_seller_verified: 'Is the Seller Verified?',
  owner_information: 'Owner Information',
  store_information: 'Store Information',
  support_information: 'Support Information',
  find_user: 'Find User',
  find_user_on_olx: 'Find User on OLX',
  user_not_found: 'User not found',
  user_not_found_register_on_olx: 'User not found. Please ask the seller to register on OLX.',
  edit_seller: 'Edit Seller',
  file_size_too_large_5mb: 'size too large; cannot be greater than 5MB',
  file: 'File',
  review_id: 'Review ID',
  spec_title_between_3_and_100_chars: 'Specification must be between 3 to 100 characters',
  spec_desc_between_1_and_250_chars: 'Description must be between 1 to 250 characters',
  product_desc_between_20_and_15000_chars: 'Description must be between 20 and 15000 characters',
  store_already_exists_against_seller: 'Store already exists against this seller',
  store_already_exists_against_user: 'Store already exists against this user',
  commission: 'Commission',
  commissions: 'Commissions',
  apply_fee_percentage: 'Apply Fee Percentage?',
  configure_individual_commissions: 'Configure Individual Commissions',
  configure_delivery_charges: 'Configure Delivery Charges',
  configure_delivery_charges_by_weight: 'Configure delivery charges by weight',
  seller_commission: 'Seller Commission',
  seller_categories: 'Seller Categories',
  category_commissions: 'Category Commissions',
  fee_percentage: 'Fee Percentage',
  fee_amount: 'Fee Amount',
  select_categories: 'Select Categories',
  yes: 'Yes',
  no: 'No',
  role_updated_successfully: 'Role updated successfully!',
  role_added_successfully: 'Role added successfully!',
  products_approved_successfully: 'Products approved successfully!',
  type_between_3_and_50_chars: 'Type must be between 3 to 50 characters',
  duration_less_than_3_chars: 'Duration must be 3 digits or less',
  policy_between_10_and_2000_chars: 'Policy must be between 10 to 2000 characters',
  store_name_between_3_and_255_chars: 'Store name must be between 3 to 255 characters',
  name_between_3_and_255_chars: 'Name must be between 3 to 255 characters',
  address_between_3_and_255_chars: 'Address must be between 3 to 255 characters',
  role_id: 'Role ID',
  edit_role: 'Edit Role',
  delete_role: 'Delete Role',
  add_role: 'Add Role',
  users: 'Users',
  role_permission: 'Role Permission',
  order_cancelled_successfully: 'Order has been successfully cancelled.',
  form_not_available: 'Form is not available',
  bank_account_title: 'Bank Account Title',
  enter_bank_account_title: 'Enter Bank Account Title',
  select_all: 'Select All',
  deselect_all: 'Deselect All',
  policy: 'Policy',
  discounted_price: 'Discounted Price',
  fixed_amount: 'Fixed Amount',
  percentage: 'Percentage',
  categories_and_commissions: 'Categories and Commissions',
  payout_amount_definition: 'Amount settled after fees and taxes.',
  categories_and_commissions_configuration: 'Categories & Commissions Configuration',
  commissions_configuration: 'Commissions Configuration',
  seller: 'Seller',
  sellerwise: 'Sellerwise',
  categorywise: 'Categorywise',
  please_specify_your_reason: 'Please specify your reason',
  additional_information: 'Additional Information',
  select_reason: 'Select Reason',
  please_select_any_reason: 'Please select any of the reasons for cancelling these order(s)',
  please_select_any_reason_rejecting_store: 'Please select a reason for rejecting this store',
  reason_between_10_50_chars: 'Reason must be between 10 and 50 characters',
  percentage_should_be_between_0_to_100: 'Percentage should be between 0 to 100',
  please_select_a_reason: 'Please select a reason',
  driving_efficiency_through_smart_system_management: 'Driving Efficiency Through Smart System Management',
  welcome_back: 'Welcome Back',
  sign_in_with_google: 'Sign in with Google',
  by_signing_up_i_agree_to_the: 'By signing up, I agree to the',
  privacy_policy: 'Privacy Policy',
  terms_and_conditions: 'Terms and Conditions',
  and: 'and',
  product_url_copied: 'Product URL copied to clipboard',
  product_rating: 'Product Rating',
  seller_rating: 'Seller Rating',
  cannot_have_two_specifications_with_same_name: 'Cannot have two specifications with the same name',
  store_id: 'Store ID',
  reference_number: 'Reference Number',
  upload_good_quality_picture_with_proper_lighting: 'Upload good quality picture with proper lighting.',
  file_pdf_png_jpeg_jpg_doc_docx: 'File type can be .pdf, .png, .jpeg, .jpg, .doc, .docx',
  transfer_amount_must_be_equal_to_the_settlement_amount: 'Transfer amount must be equal to the settlement amount',
  account_manager: 'Account Manager',
  select_account_manager: 'Select Account Manager',
  unmapped_products: 'Unmapped Products',
  error_occurred_while_updating_description: 'An error occurred while updating description',
  unit: 'Unit',
  add_specification: 'Add specification',
  add_video: 'Add Video',
  embed_video_url: 'Embed Video URL',
  seller_source: 'Seller Source',
  pakwheels_store_name: 'PakWheels Store Name',
  pakwheels_store_url: 'PakWheels Store URL',
  enter_pakwheels_store_name: 'Enter PakWheels Store Name',
  enter_pakwheels_store_url: 'Enter PakWheels Store URL',
  replica_products: 'Product Replicas',
  failed_payload: 'Failed Payload',
  import_csv: 'Import CSV',
  upload_csv: 'Upload CSV',
  publish: 'Publish',
  retry_onboarding: 'Retry Onboarding',
  are_you_sure_resync_products: 'Are you sure you want to resync products for this seller?',
  are_you_sure_welcome_email: 'Are you sure you want to send welcome email to this seller?',
  are_you_sure_publish_seller: 'Are you sure you want to publish this seller?',
  publish_seller: 'Publish Seller',
  resync_products: 'Resync Products',
  resync_draft_products: 'Resync Draft Products',
  store_banner_web: 'Store Banner (Web)',
  store_banner_mobile: 'Store Banner (Mobile)',
  are_you_sure_retry_onboard_store: 'Are you sure you want to retry the store onboarding process?',
  retry_store_onboarding: 'Retry Store Onboarding',
  skip_this_step: 'Skip this step',
  external_id: 'External ID',
  enter_external_id: 'Enter External ID',
  store_type: 'Store Type',
  actual: 'Actual',
  test: 'Test',
  crm_client_phone_number: 'CRM Client Phone Number',
  search: 'Search',
  crm_client_is_required: 'CRM Client is required',
  jarvis_client_is_required: 'Jarvis Client is required',
  client_name: 'Client Name',
  client_email: 'Client Email',
  client_phone: 'Client Phone Number',
  client_external_id: 'Client External ID',
  change: 'Change',
  change_address: 'Change Address',
  address_placeholder: 'House No., Street No., Town, City',
  official: 'Official',
  select_client: 'Select Client',
  jarvis_client: 'Jarvis Client',
  jarvis_external_id: 'Jarvis External ID',
  is_test_account: 'Is Test Account?',
  flag_ship_store: 'Flagship Store?',
  seller_synced: 'Seller Synced',
  product_synced: 'Product Published',
  registered: 'Registered',
  tax_info_verified: 'Tax Info Verified?',
  jarvis_client_id: 'Jarvis Client ID',
  olx_external_id: 'OLX External ID',
  enter_olx_external_id: 'Enter OLX External ID',
  show_phone_number: 'Show Phone Number',
  payment_option: 'Payment Option',
  end_date: 'End Date',
  vacation_mode: 'Vacation Mode',
  end_date_optional: 'End Date (optional)',
  enable_vacation_mode: 'Enable Vacation Mode',
  vacation_time_period: 'Vacation Time Period',
  upload_fulfillment_sheet: 'Upload Fulfillment Sheet',
  upload_payout_sheet: 'Upload Payout Sheet',
  fulfillment_sheet: 'Fulfillment Sheet',
  payout_sheet: 'Payout Sheet',
  file_csv_xls_xlsx: 'File type can be .csv, .xls, .xlsx',
  file_xls_xlsx: 'File type can be .xls, .xlsx',
  file_csv: 'File type can be .csv',
  only_upload_file_provided_by_logistics_partner: 'Only upload file provided by our logistics partner',
  upload_only_one_attachment: 'Upload only one attachment',
  upload_fulfillment: 'Upload Fulfillment',
  upload_payout: 'Upload Payout',
  export_orders: 'Export Orders',
  export_settlement_sheet: 'Export Settlement',
  export_finance_sheet: 'Export Finance Sheet',
  select_end_date_optional: 'Select End Date (optional)',
  vacation_mode_text:
    "Your store and listings will be hidden from buyers in the time period shown below. You won't receive any new orders while Vacation Mode is on.",
  enable: 'Enable',
  pre_vacation_mode_text:
    "Hide your store and listings while you're away. You won't receive orders or be visible to buyers during this time.",
  set_the_duration: 'Set the duration',
  select_start_date: 'Select Start Date',
  start_date_is_required: 'Start Date is required',
  disable_vacation_mode: 'Disable Vacation Mode?',
  disable_vacation_mode_text:
    "Your store and listings will become visible to buyers immediately, and you'll start receiving orders again.",
  disable: 'Disable',
  store_and_listings_hidden_on_olx: 'Your store and listings are hidden on OLX',
  until: 'until',
  you_are_on_vacation_mode: 'You are on Vacation Mode',
  tax_verification_in_process:
    "Your tax information is currently under verification. Once completed, you'll be able to access your store.",
  tax_info_missing_message:
    'Please share your STRN to continue using your store. As per government regulations, this information is mandatory to proceed.',
  tax_verification_in_process_title: 'Information Under Verification',
  tax_info_missing_title: 'Reminder: Tax Information Needed',
  tax_verification_failed_title: 'Verification Failed',
  tax_verification_failed_message:
    'We were unable to verify the tax details you provided. Please check and update your information to ensure it is correct.',
  discount_must_be_atleast_1_percent: 'Discount must be at least 1%',
  on_vacation: 'On Vacation',
  download_app_now: 'Download the Seller Center App Now!',
  dont_have_account: 'New to OLX Seller Center?',
  start_selling: 'Start Selling',
  sign_up: 'Sign up',
  sign_up_capitalize: 'Sign Up',
  courier_service: 'Courier Service',
  computer_generated_receipt: 'This is a computer generated statement and does not require a signature.',
  select_courier_service: 'Select Courier Service',
  enter_product_id: 'Enter Product ID',
  enter: 'Enter',
  temporary_issue_occurred: 'A temporary issue occurred. Tap to retry or come back shortly.',
  oops_text: 'Oops! Something went wrong',
  all_images: 'Images',
  terms_of_use: 'Terms of Use',
  count: 'Count',
  stock_status: 'Stock Status',
  invoice_id: 'Invoice ID',
  max_50_images_allowed: 'Maximum 50 images are allowed',
  update_buyer_details: 'Update Buyer Details',
  real_time_statistics: 'Real-time Statistics',
  enter_fullscreen: 'Enter Fullscreen',
  exit_fullscreen: 'Exit Fullscreen',
  fullscreen: 'Fullscreen',
  awaiting_buyer_confirmation: 'Awaiting Buyer Confirmation',
  awaiting_seller_confirmation: 'Awaiting Seller Confirmation',
  pending: 'Pending',
  order_statistics: 'Order Stats',
  dubizzle_external_id: 'Dubizzle External ID',
  enter_dubizzle_external_id: 'Enter Dubizzle External ID',
  add_new_variant: 'Add new variant',
  select_variant: 'Select Variant',
  add_custom_variant: 'Add Custom Variant',
  delivery_rates_update: 'Delivery rates updated successfully',
  this_field_requires_at_least: 'This field requires at least',
  images_lowercase: 'images',
  no_warehouse_delivery_charges_configured: 'No warehouse delivery charges configured',
  reference_id: 'Reference ID',
  contact: 'Contact',
  call_info: 'Call Info',
  caller_and_recording: 'Caller & Recording',
  caller: 'Caller',
  recording: 'Recording',
  timeline: 'Timeline',
  olx_copyright_text: 'OLX Pakistan - Copyright © 2006 - ',
  time_taken_to_move_from_previous_status: 'Time taken to move from the previous status',
  expected_delivery_days: 'Expected Delivery Days',
  max_delivery_days: 'Max Delivery Days',
  enter_max_delivery_days: 'Enter Maximum Delivery Days',
  enabled_for_seller: 'Enabled for Seller',
  disabled_for_seller: 'Disabled for Seller',
  expected_delivery_days_required: 'Expected Delivery Days are required',
  row: 'Row',
  errors: 'Errors',
  min_price_is: 'Minimum price is',
  max_price_is: 'Maximum price is',
  min_discounted_price_is: 'Minimum discounted price is',
  max_discounted_price_is: 'Maximum discounted price is',
  cart_listing: 'Carts',
  update_password: 'Update Password',
  privacy_security: 'Privacy & Security',
  old_password: 'Old Password',
  enter_old_password: 'Enter Old Password',
  confirm_password: 'Confirm Password',
  enter_confirm_password: 'Enter Confirm Password',
  enter_new_password: 'Enter New Password',
  password_mismatch: 'Passwords does not match',
  password_updated_successfully: 'Password updated successfully',
  cart_items: 'Cart Items',
  domain_not_allowed: 'Domain is not allowed',
  average_order_delivery_time: 'Avg. Delivery Time',
  returns: 'Returns',
  are_you_sure_change_order: 'Are you sure you want to proceed with these changes to the order?',
  variant_id: 'Variant ID',
  update_order: 'Update Order',
  remove_product: 'Remove Product',
  are_you_sure_remove_product: 'Are you sure you want to remove this product?',
  add_more_products: 'Add More Products',
  existing_products: 'Existing Products',
  new_products: 'New Products',
  reset_filters: 'Reset Filters',
  paid_amount: 'Paid Amount',
  fulfillment_status: 'Fulfillment Status',
  payment_id: 'Payment ID',
  payment_gateway: 'Payment Gateway',
  payments_listing: 'Payments Listing',
  payments: 'Payments',
  advance_payment: 'Advance Payment',
  generate_payment_link: 'Generate Payment Link',
  refund_payment_proof: 'Refund Payment Proof',
  generate: 'Generate',
  store_uploads: 'Store Uploads',
  creation_date: 'Creation Date',
  date_and_time: 'Date And Time',
  receiver: 'Receiver',
  date_time: 'Date & Time',
  duration: 'Duration',
  caller: 'Call Agent',
  recording: 'Recording',
  dialer: 'Dialer',
  call_type: 'Call Type',
  answered: 'Answered',
  unanswered: 'Unanswered',
  outgoing: 'Outgoing',
  incoming: 'Incoming',
  transcription: 'Transcription',
  no_transcription_available: 'No Transcription Available',
  initiate_call: 'Initiate Call',
  call_buyer: 'Call Buyer',
  transcription_in_progress:
    'We are currently analyzing your call to provide you with a transcription. Please wait while we gather all the important details for you.',
  departments: 'Departments',
  audio: 'Audio',
  account_under_review: 'Account Under Review',
  your_account_under_review:
    'Your account information is currently under review. We will let you know once your account is verified.',
  account_rejected: 'Account Review Unsuccessful',
  your_account_rejected:
    'Your account was rejected as it due to incomplete or invalid information. Please update your information.',
  feature_locked_as_account_pending: 'This feature will be available after your account is verified.',
  update_account_information: 'Update Account Information',
  removed: 'Removed',
  account_information_incomplete: 'Incomplete Account Information',
  make_sure_to_title_bank_iban: 'Please fill in your bank details.',
  three_pl_enabled: '3PL Enabled?',
  self_delivery_seller: 'Self-delivery Seller?',
  what_defines_you_best: 'What defines you best?',
  select_what_defines_you_best: 'Select what defines you best',
  net_earning_definition: "Platform's total earnings excluding the shipping and return fees paid by OLX.",
  kpis: 'KPIs',
  todos: 'Todos',
  tasks: 'Tasks',
  completed_tasks: 'Completed Tasks',
  follow_ups: 'Follow Ups',
  mark_as_completed: 'Mark as completed',
  tags: 'Tags',
  appeals: 'Appeals',
  performance: 'Performance',
  store: 'Store',
  penalty_reason: 'Penalty Reason',
  appeal_reason: 'Appeal Reason',
  penalty: 'Penalty',
  date: 'Date',
  appeal_status: 'Appeal Status',
  resync: 'Resync',
};
